export default {
  primary: "#f57c00",
  secondary: "#039be5",
  black: "#222222",
  white: "#ffffff",
  ghostWhite: "#f8f8ff",
  lightGrey: "#f9f9f9",
  mediumGrey: "#6e6869",
  red: "#fc5c65",

  Background: "#011936",
  BottomNavigationBar: "#010d1c",
  IconSelected: "#ffffff",
  TextColour: "#ffffff",
  FakeTextColour: "#000000",
  IconDeselected: "#b3b3b3",
  Red: "#ff8080",
  LightRed: "#ffbfbf",
  Orange: "#ffdf80",
  LightOrange: "#ffefbf",
  yellow: "#c0ff80",
  LightYellow: "#dfffbf",
  Green: "#80ffa0",
  LightGreen: "#bfffcf",
  Teal: "#80ffff",
  LightTeal: "#bfffff",
  Blue: "#80a0ff",
  LightBlue: "#bfcfff",
};
